// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watch-now-button[data-v-9dd7eaf2] button.basic-button.secondary{font-weight:500}.watch-now-button[data-v-9dd7eaf2] .basic-button__content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.watch-now-button[data-v-9dd7eaf2]::v-deep-contents{display:flex;gap:4px;align-items:center}", ""]);
// Exports
module.exports = exports;
